import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";

const WhoWeAre = () => {
  const slides = [
    { img: '/images/image.png', label: 'Worship' },
    { img: '/images/cm8.jpeg',                  label: 'Community' },
    { img: '/images/m5.jpg',                  label: 'Prayer' },
    { img: '/images/choir.png',               label: 'Praise' },
    { img: '/images/m1.jpg',              label: 'Ministry' },
  ];

  const [current, setCurrent]   = useState(0);
  const [leaving, setLeaving]   = useState(null);
  const [animKey, setAnimKey]   = useState(0);
  const timerRef                = useRef(null);

  const goTo = (idx) => {
    if (idx === current) return;
    setLeaving(current);
    setCurrent(idx);
    setAnimKey(k => k + 1);
    clearInterval(timerRef.current);
    startTimer(idx);
  };

  const startTimer = (from) => {
    let cur = from ?? current;
    timerRef.current = setInterval(() => {
      setLeaving(cur);
      cur = (cur + 1) % slides.length;
      setCurrent(cur);
      setAnimKey(k => k + 1);
    }, 5200);
  };

  useEffect(() => {
    startTimer(0);
    return () => clearInterval(timerRef.current);
  }, []);

  return (
    <>
      <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" rel="stylesheet" />
      <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.min.css" />

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,600;0,700;1,400;1,600&family=Outfit:wght@300;400;500;600&display=swap');

        :root {
          --navy:   #0b1c6b;
          --royal:  #1a3aa1;
          --sky:    #159EEC;
          --ink:    #111827;
          --slate:  #4b5563;
          --silver: #f3f6fb;
          --line:   #e4eaf5;
          --white:  #ffffff;
        }

        *, *::before, *::after { box-sizing: border-box; }

        .wwa-page {
          font-family: 'Outfit', sans-serif;
          color: var(--ink);
          background: var(--white);
          overflow-x: hidden;
        }

        /* ══════════════════════════════════════════
           PREMIUM HERO
        ══════════════════════════════════════════ */
        .wwa-hero {
          position: relative;
          height: 90vh;
          min-height: 580px;
          overflow: hidden;
          display: flex;
          align-items: flex-end;
          background: var(--navy);
        }

        /* ── Slide layer ── */
        .wwa-slide {
          position: absolute;
          inset: 0;
          background-size: cover;
          background-position: center top;
          opacity: 0;
          z-index: 0;
          will-change: transform, opacity;
        }

        .wwa-slide.entering {
          z-index: 2;
          animation: kbEnter 6s ease-out forwards;
        }

        .wwa-slide.leaving {
          z-index: 1;
          animation: kbLeave 1.4s ease-in forwards;
        }

        @keyframes kbEnter {
          0%   { opacity: 0; transform: scale(1.13) translateX(12px); }
          6%   { opacity: 1; }
          100% { opacity: 1; transform: scale(1.0) translateX(0px); }
        }

        @keyframes kbLeave {
          0%   { opacity: 1; }
          100% { opacity: 0; }
        }

        /* ── Multi-layer overlay for cinematic depth ── */
        .wwa-slide::before {
          content: '';
          position: absolute;
          inset: 0;
          background: linear-gradient(
            135deg,
            rgba(11,28,107,0.78) 0%,
            rgba(11,28,107,0.18) 55%,
            rgba(0,0,0,0.52) 100%
          );
          z-index: 1;
        }

        .wwa-slide::after {
          content: '';
          position: absolute;
          inset: 0;
          background: linear-gradient(
            to top,
            rgba(11,28,107,0.95) 0%,
            rgba(11,28,107,0.3)  35%,
            transparent          70%
          );
          z-index: 2;
        }

        /* ── Floating particles ── */
        .wwa-hero-particles {
          position: absolute;
          inset: 0;
          z-index: 5;
          pointer-events: none;
          overflow: hidden;
        }

        .wwa-particle {
          position: absolute;
          border-radius: 50%;
          background: rgba(255,255,255,0.5);
          animation: particleFloat linear infinite;
        }

        @keyframes particleFloat {
          0%   { transform: translateY(0) scale(1); opacity: 0; }
          15%  { opacity: 0.8; }
          80%  { opacity: 0.3; }
          100% { transform: translateY(-90vh) scale(0.2); opacity: 0; }
        }

        /* ── Ambient light sweep ── */
        .wwa-light-sweep {
          position: absolute;
          inset: 0;
          z-index: 4;
          pointer-events: none;
          background: radial-gradient(
            ellipse 60% 80% at 20% 40%,
            rgba(21,158,236,0.10) 0%,
            transparent 70%
          );
          animation: lightPulse 8s ease-in-out infinite;
        }

        @keyframes lightPulse {
          0%, 100% { opacity: 0.5; transform: translateX(0); }
          50%       { opacity: 1;   transform: translateX(6%); }
        }

        /* ── Horizontal scan lines for texture ── */
        .wwa-scan-line {
          position: absolute;
          left: 0; right: 0;
          height: 1px;
          background: linear-gradient(90deg, transparent, rgba(21,158,236,0.15), transparent);
          z-index: 4;
          pointer-events: none;
          animation: scanLine linear infinite;
        }

        @keyframes scanLine {
          0%   { top: -2px; opacity: 0; }
          10%  { opacity: 1; }
          90%  { opacity: 0.25; }
          100% { top: 102%; opacity: 0; }
        }

        /* ── Bottom cutout ── */
        .wwa-hero-cutout {
          position: absolute;
          bottom: -2px; left: 0; right: 0;
          height: 90px;
          background: var(--white);
          clip-path: ellipse(55% 100% at 50% 100%);
          z-index: 10;
          pointer-events: none;
        }

        /* ── Slide counter top-left ── */
        .wwa-hero-counter {
          position: absolute;
          top: clamp(20px, 4vw, 40px);
          left: clamp(24px, 5vw, 60px);
          z-index: 12;
          color: rgba(255,255,255,0.55);
          font-size: 0.7rem;
          font-weight: 600;
          letter-spacing: 0.12em;
          display: flex;
          align-items: baseline;
          gap: 4px;
        }

        .wwa-hero-counter .big {
          font-size: 2rem;
          font-weight: 700;
          color: #fff;
          line-height: 1;
          font-family: 'Cormorant Garamond', serif;
        }

        /* ── Slide label top-right ── */
        .wwa-hero-label {
          position: absolute;
          top: clamp(20px, 4vw, 40px);
          right: clamp(24px, 5vw, 60px);
          z-index: 12;
          color: rgba(255,255,255,0.6);
          font-size: 0.68rem;
          font-weight: 600;
          letter-spacing: 0.2em;
          text-transform: uppercase;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .wwa-hero-label::before {
          content: '';
          display: inline-block;
          width: 20px;
          height: 1.5px;
          background: var(--sky);
        }

        /* ── Progress bar bottom ── */
        .wwa-hero-progress {
          position: absolute;
          bottom: 0; left: 0; right: 0;
          height: 3px;
          z-index: 15;
          display: flex;
          gap: 2px;
        }

        .wwa-prog-seg {
          flex: 1;
          background: rgba(255,255,255,0.12);
          position: relative;
          overflow: hidden;
        }

        .wwa-prog-fill {
          position: absolute;
          inset: 0;
          background: linear-gradient(90deg, var(--sky), var(--royal));
          transform: scaleX(0);
          transform-origin: left;
        }

        .wwa-prog-fill.animating {
          animation: progFill 5.2s linear forwards;
        }

        @keyframes progFill {
          from { transform: scaleX(0); }
          to   { transform: scaleX(1); }
        }

        /* ── Dot navigation ── */
        .wwa-hero-dots {
          position: absolute;
          right: clamp(20px, 4vw, 50px);
          top: 50%;
          transform: translateY(-50%);
          z-index: 12;
          display: flex;
          flex-direction: column;
          gap: 10px;
          align-items: center;
        }

        .wwa-dot {
          width: 8px; height: 8px;
          border-radius: 50%;
          background: rgba(255,255,255,0.25);
          border: 1.5px solid rgba(255,255,255,0.5);
          cursor: pointer;
          transition: all 0.35s cubic-bezier(0.34,1.56,0.64,1);
          padding: 0;
          position: relative;
        }

        .wwa-dot.active {
          background: var(--sky);
          border-color: var(--sky);
          transform: scale(1.55);
          box-shadow: 0 0 0 4px rgba(21,158,236,0.22);
        }

        .wwa-dot::after {
          content: '';
          position: absolute;
          inset: -5px;
        }

        /* ── Decorative vertical line ── */
        .wwa-hero-vline {
          position: absolute;
          left: clamp(24px,5vw,60px);
          top: 50%;
          transform: translateY(-50%);
          width: 2px;
          height: clamp(60px, 10vw, 120px);
          background: linear-gradient(to bottom, transparent, var(--sky), transparent);
          z-index: 6;
          animation: vlinePulse 3s ease-in-out infinite;
        }

        @keyframes vlinePulse {
          0%, 100% { opacity: 0.4; }
          50%       { opacity: 1; }
        }

        /* ── Hero content ── */
        .wwa-hero-inner {
          position: relative;
          z-index: 11;
          padding: 0 clamp(24px, 6vw, 100px) clamp(70px, 9vw, 120px);
          color: var(--white);
          max-width: 800px;
        }

        .wwa-hero-eyebrow {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          font-size: 0.7rem;
          font-weight: 600;
          letter-spacing: 0.2em;
          text-transform: uppercase;
          color: rgba(255,255,255,0.65);
          margin-bottom: 16px;
        }

        .wwa-hero-eyebrow::before {
          content: '';
          display: inline-block;
          width: 32px; height: 2px;
          background: var(--sky);
          border-radius: 1px;
        }

        .wwa-hero h1 {
          font-family: 'Cormorant Garamond', serif;
          font-size: clamp(3.2rem, 7.5vw, 6rem);
          font-weight: 700;
          line-height: 1.03;
          margin-bottom: 16px;
          letter-spacing: -0.02em;
        }

        .wwa-hero h1 em {
          font-style: italic;
          color: var(--sky);
        }

        .wwa-hero p {
          font-size: clamp(0.95rem, 1.8vw, 1.15rem);
          font-weight: 300;
          color: rgba(255,255,255,0.72);
          line-height: 1.7;
          max-width: 520px;
        }

        /* Text entry animations keyed on slide change */
        .wwa-hero-eyebrow { animation: heroFadeUp 0.9s cubic-bezier(0.22,1,0.36,1) both; }
        .wwa-hero h1      { animation: heroFadeUp 0.9s cubic-bezier(0.22,1,0.36,1) 0.08s both; }
        .wwa-hero p       { animation: heroFadeUp 0.9s cubic-bezier(0.22,1,0.36,1) 0.18s both; }

        @keyframes heroFadeUp {
          from { opacity: 0; transform: translateY(24px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        /* ── EVERYTHING BELOW: unchanged from original ── */
        .wwa-section {
          padding: clamp(64px, 8vw, 110px) clamp(24px, 5vw, 60px);
          background: var(--white);
        }

        .wwa-section.silver { background: var(--silver); }
        .wwa-section-inner  { max-width: 1180px; margin: 0 auto; }

        .wwa-row {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: clamp(40px, 5vw, 80px);
          align-items: stretch;
        }

        .wwa-row.reverse .wwa-img-col  { order: 2; }
        .wwa-row.reverse .wwa-text-col { order: 1; }

        @media (max-width: 900px) {
          .wwa-row { grid-template-columns: 1fr; }
          .wwa-row.reverse .wwa-img-col  { order: unset; }
          .wwa-row.reverse .wwa-text-col { order: unset; }
          .wwa-img-frame { min-height: 280px; }
          .wwa-img-frame::before,
          .wwa-img-frame::after { display: none; }
          .wwa-hero { height: 72vh; }
          .wwa-hero-dots { right: 14px; }
        }

        .wwa-img-col { position: relative; }

        .wwa-img-frame {
          width: 100%; height: 100%; min-height: 420px;
          border-radius: 20px; overflow: hidden; position: relative;
        }

        .wwa-img-frame img {
          width: 100%; height: 100%;
          object-fit: cover; object-position: center top; display: block;
          transition: transform 0.7s cubic-bezier(0.25,0.46,0.45,0.94);
        }

        .wwa-img-frame:hover img { transform: scale(1.04); }

        .wwa-img-frame::before {
          content: ''; position: absolute; top: -12px; left: -12px;
          width: 80px; height: 80px;
          border-top: 3px solid var(--sky); border-left: 3px solid var(--sky);
          border-radius: 4px; z-index: 2; pointer-events: none;
        }

        .wwa-img-frame::after {
          content: ''; position: absolute; bottom: -12px; right: -12px;
          width: 80px; height: 80px;
          border-bottom: 3px solid var(--navy); border-right: 3px solid var(--navy);
          border-radius: 4px; z-index: 2; pointer-events: none;
        }

        .wwa-text-col { display: flex; flex-direction: column; justify-content: center; gap: 0; }

        .wwa-eyebrow {
          display: inline-flex; align-items: center; gap: 9px;
          font-size: 0.7rem; font-weight: 700; letter-spacing: 0.16em;
          text-transform: uppercase; color: var(--sky); margin-bottom: 14px;
        }

        .wwa-eyebrow::before {
          content: ''; display: inline-block; width: 22px; height: 2px;
          background: var(--sky); border-radius: 1px;
        }

        .wwa-heading {
          font-family: 'Cormorant Garamond', serif;
          font-size: clamp(2rem, 3.5vw, 3rem); font-weight: 700;
          color: var(--navy); line-height: 1.15; margin-bottom: 20px;
          letter-spacing: -0.01em;
        }

        .wwa-body {
          font-size: 0.97rem; line-height: 1.85; color: var(--slate);
          font-weight: 300; margin-bottom: 28px;
        }

        .wwa-body strong { color: var(--ink); font-weight: 600; }

        .wwa-callout {
          background: linear-gradient(135deg, rgba(11,28,107,0.04), rgba(21,158,236,0.06));
          border: 1px solid var(--line); border-left: 3px solid var(--sky);
          border-radius: 12px; padding: 22px 24px; margin-top: 4px;
        }

        .wwa-callout-title {
          font-size: 0.85rem; font-weight: 700; color: var(--navy);
          margin-bottom: 10px; display: flex; align-items: center; gap: 8px;
        }

        .wwa-callout-title i { color: var(--sky); font-size: 1rem; }

        .wwa-callout p {
          font-size: 0.9rem; line-height: 1.78; color: var(--slate); margin: 0; font-weight: 300;
        }

        .wwa-checklist {
          list-style: none; padding: 0; margin: 0;
          display: flex; flex-direction: column; gap: 10px;
        }

        .wwa-checklist li {
          display: flex; align-items: flex-start; gap: 10px;
          font-size: 0.92rem; color: var(--slate); font-weight: 400; line-height: 1.6;
        }

        .wwa-check-icon {
          width: 20px; height: 20px; min-width: 20px; border-radius: 50%;
          background: linear-gradient(135deg, var(--sky), var(--royal));
          display: flex; align-items: center; justify-content: center; margin-top: 1px;
        }

        .wwa-check-icon i { font-size: 0.65rem; color: white; }

        .wwa-focus-box {
          background: var(--white); border: 1px solid var(--line);
          border-radius: 16px; padding: 24px 28px;
          box-shadow: 0 4px 24px rgba(11,28,107,0.06); margin-top: 28px;
        }

        .wwa-focus-box-title {
          font-size: 0.85rem; font-weight: 700; color: var(--navy);
          margin-bottom: 16px; display: flex; align-items: center; gap: 8px;
        }

        .wwa-focus-box-title i { color: var(--sky); }

        .wwa-section-header { text-align: center; margin-bottom: clamp(40px, 5vw, 60px); }
        .wwa-section-header .wwa-eyebrow { justify-content: center; }
        .wwa-section-header .wwa-heading { font-size: clamp(2rem, 4vw, 3.2rem); }

        .wwa-values-grid { display: grid; grid-template-columns: repeat(3,1fr); gap: 24px; }
        @media (max-width: 768px) { .wwa-values-grid { grid-template-columns: 1fr; } }

        .wwa-value-card {
          background: var(--white); border: 1px solid var(--line);
          border-radius: 20px; padding: clamp(28px,3vw,40px) 28px;
          text-align: center; position: relative; overflow: hidden;
          transition: transform 0.3s, box-shadow 0.3s;
        }

        .wwa-value-card::before {
          content: ''; position: absolute; top: 0; left: 0; right: 0;
          height: 3px; background: linear-gradient(90deg, var(--sky), var(--royal));
          transform: scaleX(0); transform-origin: left; transition: transform 0.35s ease;
        }

        .wwa-value-card:hover { transform: translateY(-6px); box-shadow: 0 16px 48px rgba(11,28,107,0.1); }
        .wwa-value-card:hover::before { transform: scaleX(1); }

        .wwa-value-icon {
          width: 64px; height: 64px; border-radius: 16px;
          background: linear-gradient(135deg, rgba(21,158,236,0.1), rgba(26,58,161,0.08));
          border: 1px solid rgba(21,158,236,0.15);
          display: flex; align-items: center; justify-content: center;
          margin: 0 auto 20px; font-size: 1.6rem; color: var(--royal);
          transition: background 0.3s;
        }

        .wwa-value-card:hover .wwa-value-icon {
          background: linear-gradient(135deg, var(--sky), var(--royal));
          color: white; border-color: transparent;
        }

        .wwa-value-title {
          font-family: 'Cormorant Garamond', serif;
          font-size: 1.35rem; font-weight: 700; color: var(--navy); margin-bottom: 10px;
        }

        .wwa-value-desc {
          font-size: 0.88rem; color: var(--slate); line-height: 1.72; font-weight: 300; margin: 0;
        }

        .wwa-divider { width: 100%; height: 1px; background: var(--line); margin: 0; }

        .wwa-social {
          background: var(--navy);
          padding: clamp(56px,7vw,96px) clamp(24px,5vw,60px);
          text-align: center; color: var(--white); position: relative; overflow: hidden;
        }

        .wwa-social::before {
          content: ''; position: absolute; inset: 0;
          background: radial-gradient(ellipse 70% 80% at 20% 50%,rgba(21,158,236,0.12) 0%,transparent 60%),
                      radial-gradient(ellipse 50% 60% at 80% 50%,rgba(26,58,161,0.3) 0%,transparent 55%);
          pointer-events: none;
        }

        .wwa-social-inner { position: relative; z-index: 1; max-width: 600px; margin: 0 auto; }

        .wwa-social h2 {
          font-family: 'Cormorant Garamond', serif;
          font-size: clamp(2rem,4vw,3rem); font-weight: 700; margin-bottom: 12px;
        }

        .wwa-social p {
          font-size: 0.95rem; color: rgba(255,255,255,0.65);
          font-weight: 300; line-height: 1.7; margin-bottom: 36px;
        }

        .wwa-social-links { display: flex; justify-content: center; gap: 14px; flex-wrap: wrap; }

        .wwa-social-link {
          width: 52px; height: 52px; border-radius: 50%;
          border: 1px solid rgba(255,255,255,0.18);
          background: rgba(255,255,255,0.06);
          color: var(--white); display: flex; align-items: center; justify-content: center;
          font-size: 1.25rem; text-decoration: none; transition: all 0.28s;
        }

        .wwa-social-link:hover {
          background: var(--sky); border-color: var(--sky); color: var(--white);
          transform: translateY(-4px); box-shadow: 0 8px 24px rgba(21,158,236,0.4);
        }
      `}</style>

      <div className="wwa-page">

        {/* ══════════════════════════════════════════
            PREMIUM HERO — updated
        ══════════════════════════════════════════ */}
        <section className="wwa-hero">

          {/* Slide images with Ken Burns */}
          {slides.map((slide, i) => (
            <div
              key={i}
              className={`wwa-slide ${
                i === current ? 'entering' : i === leaving ? 'leaving' : ''
              }`}
              style={{ backgroundImage: `url(${slide.img})` }}
            />
          ))}

          {/* Ambient light sweep */}
          <div className="wwa-light-sweep" />

          {/* Floating particles */}
          <div className="wwa-hero-particles">
            {[...Array(20)].map((_, i) => {
              const size  = Math.random() * 3 + 1.5;
              const left  = Math.random() * 100;
              const delay = Math.random() * 10;
              const dur   = Math.random() * 10 + 8;
              return (
                <div
                  key={i}
                  className="wwa-particle"
                  style={{
                    width:  `${size}px`,
                    height: `${size}px`,
                    left:   `${left}%`,
                    bottom: `${Math.random() * 20}%`,
                    animationDuration:  `${dur}s`,
                    animationDelay:     `${delay}s`,
                  }}
                />
              );
            })}
          </div>

          {/* Scan lines */}
          {[0,1,2].map(i => (
            <div
              key={i}
              className="wwa-scan-line"
              style={{
                animationDuration: `${8 + i * 3}s`,
                animationDelay:    `${i * 3.5}s`,
              }}
            />
          ))}

          {/* Decorative left vertical line */}
          <div className="wwa-hero-vline" />

          {/* Slide counter — top left */}
          <div className="wwa-hero-counter">
            <span className="big">{String(current + 1).padStart(2, '0')}</span>
            &nbsp;/ {String(slides.length).padStart(2, '0')}
          </div>

          {/* Slide label — top right */}
          <div className="wwa-hero-label">{slides[current].label}</div>

          {/* Dot navigation */}
          <div className="wwa-hero-dots">
            {slides.map((_, i) => (
              <button
                key={i}
                className={`wwa-dot ${i === current ? 'active' : ''}`}
                onClick={() => goTo(i)}
                aria-label={`Go to slide ${i + 1}`}
              />
            ))}
          </div>

          {/* Bottom cutout */}
          <div className="wwa-hero-cutout" />

          {/* Progress bar */}
          <div className="wwa-hero-progress">
            {slides.map((_, i) => (
              <div key={i} className="wwa-prog-seg">
                <div
                  key={`${i}-${animKey}`}
                  className={`wwa-prog-fill ${i === current ? 'animating' : ''}`}
                  style={i < current ? { transform: 'scaleX(1)' } : {}}
                />
              </div>
            ))}
          </div>

          {/* Hero content */}
          <div className="wwa-hero-inner" key={animKey}>
            <div className="wwa-hero-eyebrow">Gospel City Church International</div>
            <h1>About <em>GCCI</em></h1>
            <p>Growing in faith, love, and purpose</p>
          </div>
        </section>

        {/* ── ABOUT PASTOR ── */}
        <section className="wwa-section">
          <div className="wwa-section-inner">
            <div className="wwa-row">
              <div className="wwa-img-col">
                <div className="wwa-img-frame">
                  <img src="/images/pastor1.png" alt="Our Pastor" />
                </div>
              </div>
              <div className="wwa-text-col">
                <div className="wwa-eyebrow">Leadership</div>
                <h2 className="wwa-heading">About Our Pastor</h2>
                <p className="wwa-body">
                  Having had numerous encounters with God, <strong>Pr Keffah Evans Muwanguzi</strong> was led to start GCCI,
                  called to bring back the world to God's knowledge and order. He is married to <strong>Mrs Faith Muwanguzi
                  Nakaweesi</strong>, who is an employee, church minister and a leader of worship and praise at GCCI.
                </p>
                <div className="wwa-callout">
                  <div className="wwa-callout-title">
                    <i className="bi bi-book-fill"></i> Our Belief
                  </div>
                  <p>
                    There is only One True living God, holy and perfect, creator of universe. He created man without sin,
                    sicknesses, aging and death, to live on earth as his permanent home.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="wwa-divider" />

        {/* ── MISSION ── */}
        <section className="wwa-section silver">
          <div className="wwa-section-inner">
            <div className="wwa-row reverse">
              <div className="wwa-img-col">
                <div className="wwa-img-frame">
                  <img src="/images/join.png" alt="Our Mission" />
                </div>
              </div>
              <div className="wwa-text-col">
                <div className="wwa-eyebrow">Our Purpose</div>
                <h2 className="wwa-heading">Our Mission</h2>
                <p className="wwa-body" style={{ marginBottom: 10 }}>
                  <strong>To make the world know God.</strong>
                </p>
                <div className="wwa-callout" style={{ marginBottom: 24 }}>
                  <div className="wwa-callout-title">
                    <i className="bi bi-mortarboard-fill"></i> Teaching
                  </div>
                  <p>
                    We teach God focusing on daily practical life and revelations. We also follow, analyze and interpret
                    visions and dreams as revealed on daily basis.
                  </p>
                </div>
                <div className="wwa-focus-box" style={{ marginTop: 0 }}>
                  <div className="wwa-focus-box-title">
                    <i className="bi bi-bullseye"></i> Our Focus
                  </div>
                  <ul className="wwa-checklist">
                    <li><span className="wwa-check-icon"><i className="bi bi-check"></i></span>Transforming the spirit person into the nature of God</li>
                    <li><span className="wwa-check-icon"><i className="bi bi-check"></i></span>Living a life free from bad practices</li>
                    <li><span className="wwa-check-icon"><i className="bi bi-check"></i></span>Physically succeeding in life with material wealth</li>
                    <li><span className="wwa-check-icon"><i className="bi bi-check"></i></span>Godly marriage and good family foundation</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="wwa-divider" />

        {/* ── VISION ── */}
        <section className="wwa-section">
          <div className="wwa-section-inner">
            <div className="wwa-row">
              <div className="wwa-img-col">
                <div className="wwa-img-frame">
                  <img src="/images/p.jpg" alt="Our Vision" />
                </div>
              </div>
              <div className="wwa-text-col">
                <div className="wwa-eyebrow">Our Direction</div>
                <h2 className="wwa-heading">Our Vision</h2>
                <p className="wwa-body">
                  <strong>That they may all get into knowledge of one holy true living God.</strong>
                </p>
                <div className="wwa-callout" style={{ marginBottom: 20 }}>
                  <div className="wwa-callout-title">
                    <i className="bi bi-star-fill"></i> Our Emphasis
                  </div>
                  <p>
                    We emphasize living a life free from bad practices, applying right deeds within yourself, family,
                    work place etc. Dealing with sicknesses, diseases and bringing God's voice on daily basis to the people.
                  </p>
                </div>
                <div className="wwa-callout">
                  <div className="wwa-callout-title">
                    <i className="bi bi-people-fill"></i> Empowerment
                  </div>
                  <p>
                    The church encourages children to go to school, people getting well placed in jobs,
                    business among other productive things as led by God and ministers to settle in ministry.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="wwa-divider" />

        {/* ── CORE VALUES ── */}
        <section className="wwa-section silver">
          <div className="wwa-section-inner">
            <div className="wwa-section-header">
              <div className="wwa-eyebrow">What We Stand For</div>
              <h2 className="wwa-heading">Core Values</h2>
            </div>
            <div className="wwa-values-grid">
              <div className="wwa-value-card">
                <div className="wwa-value-icon"><i className="bi bi-star"></i></div>
                <div className="wwa-value-title">Integrity</div>
                <p className="wwa-value-desc">Grounded in the Word of God, teaching practical application for daily living.</p>
              </div>
              <div className="wwa-value-card">
                <div className="wwa-value-icon"><i className="bi bi-heart-fill"></i></div>
                <div className="wwa-value-title">Compassion</div>
                <p className="wwa-value-desc">Showing God's love through caring for spiritual and physical needs.</p>
              </div>
              <div className="wwa-value-card">
                <div className="wwa-value-icon"><i className="bi bi-graph-up-arrow"></i></div>
                <div className="wwa-value-title">Growth</div>
                <p className="wwa-value-desc">Continuous spiritual development and practical life transformation.</p>
              </div>
            </div>
          </div>
        </section>

        {/* ── SOCIAL ── */}
        <section className="wwa-social">
          <div className="wwa-social-inner">
            <h2>Follow Us</h2>
            <p>Stay connected with Gospel City Church International through our social platforms.</p>
            <div className="wwa-social-links">
              <a href="https://www.linkedin.com/in/gospel-city-church-international-650a562a0/" target="_blank" rel="noopener noreferrer" className="wwa-social-link">
                <i className="bi bi-linkedin"></i>
              </a>
              <a href="https://groups.imo.im/.5l9akqTOrYa5Tv4T4" target="_blank" rel="noopener noreferrer" className="wwa-social-link">
                <i className="bi bi-chat-dots"></i>
              </a>
              <a href="https://x.com/GospelCityChur?t=x8dsFbFkghmYh02lV0FVxQ&s=03" target="_blank" rel="noopener noreferrer" className="wwa-social-link">
                <i className="bi bi-twitter-x"></i>
              </a>
              <a href="https://whatsapp.com/channel/0029Vb769UyDzgTBAZZcb40F" target="_blank" rel="noopener noreferrer" className="wwa-social-link">
                <i className="bi bi-whatsapp"></i>
              </a>
              <a href="https://youtube.com/@gospelcitychurchinternational?si=1pZx2ak4ss3b4HuU" target="_blank" rel="noopener noreferrer" className="wwa-social-link">
                <i className="bi bi-youtube"></i>
              </a>
            </div>
          </div>
        </section>

      </div>
    </>
  );
};

export default WhoWeAre;